import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { BackgroundAudio } from '../components/BackgroundAudio';
// Performance: tracking & framer-motion removed from critical bundle
// tracking is dynamically imported in useEffect and click handlers
const ClaridadSection = lazy(() => import('../components/ClaridadSection').then(m => ({
  default: m.ClaridadSection
})));
const QueEsSection = lazy(() => import('../components/QueEsSection').then(m => ({
  default: m.QueEsSection
})));
const TestimoniosSection = lazy(() => import('../components/TestimoniosSection').then(m => ({
  default: m.TestimoniosSection
})));
const MetodoSection = lazy(() => import('../components/MetodoSection').then(m => ({
  default: m.MetodoSection
})));
const MecanismoNuevoSection = lazy(() => import('../components/MecanismoNuevoSection').then(m => ({
  default: m.MecanismoNuevoSection
})));
const QueIncluyeSection = lazy(() => import('../components/QueIncluyeSection').then(m => ({
  default: m.QueIncluyeSection
})));
const LifestyleSection = lazy(() => import('../components/LifestyleSection').then(m => ({
  default: m.LifestyleSection
})));
const PersonalizaSection = lazy(() => import('../components/PersonalizaSection').then(m => ({
  default: m.PersonalizaSection
})));
const EmotionalCloseSection = lazy(() => import('../components/EmotionalCloseSection').then(m => ({
  default: m.EmotionalCloseSection
})));
const IdentitySection = lazy(() => import('../components/IdentitySection').then(m => ({
  default: m.IdentitySection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SalesNotification = lazy(() => import('../components/SalesNotification').then(m => ({
  default: m.SalesNotification
})));
export function LandingPage() {
  useEffect(() => {
    // Initialize Meta Pixel — ONLY on the landing/sales page
    const w = window as any;
    if (!w.fbq) {
      const n = w.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      w.fbq('init', '919180517627113');
      w.fbq('track', 'PageView');
    }
    // === BLOCKER: Intercept and DROP banned custom events ===
    // This catches events from ANY source (external scripts, tag managers, etc.)
    const BANNED_EVENTS = new Set(['scroll_depth', 'cta_click', 'upsell_view', 'upsell_accept', 'upsell_reject', 'UpsellAccepted']);
    if (w.fbq && !w.__fbqBlocked) {
      const originalFbq = w.fbq;
      w.fbq = function (...args: any[]) {
        const method = args[0]; // 'track', 'trackCustom', etc.
        const eventName = args[1];
        // Block banned events from both 'track' and 'trackCustom'
        if ((method === 'track' || method === 'trackCustom') && typeof eventName === 'string' && BANNED_EVENTS.has(eventName)) {
          if (import.meta.env?.DEV) {
            console.warn(`[Pixel BLOCKED] ${method}('${eventName}') — dropped`);
          }
          return; // silently drop
        }
        return originalFbq.apply(this, args);
      };
      // Preserve all properties from original fbq
      Object.keys(originalFbq).forEach(key => {
        if (!(key in w.fbq)) {
          w.fbq[key] = originalFbq[key];
        }
      });
      w.fbq.queue = originalFbq.queue;
      w.fbq.push = w.fbq;
      w.__fbqBlocked = true; // prevent double-wrapping
    }
    // === END BLOCKER ===
    // Load fbevents.js — deferred to not block FCP/LCP
    const loadPixelScript = () => {
      if (document.querySelector('script[src*="fbevents.js"]')) return;
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=919180517627113&ev=PageView&noscript=1';
      document.body.appendChild(img);
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixelScript, {
        timeout: 1500
      });
    } else {
      setTimeout(loadPixelScript, 800);
    }
    // Fire ViewContent once on landing page load
    import('../lib/tracking').then(m => m.trackViewContent());
  }, []);
  return <div className="min-h-screen bg-dark font-sans text-white selection:bg-gold/30 selection:text-gold overflow-x-hidden w-full relative" data-id="element-726">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[99999] focus:bg-gold focus:text-dark focus:px-4 focus:py-2 focus:rounded focus:font-bold" data-id="element-727">
        Saltar al contenido principal
      </a>

      <Navbar data-id="element-728" />

      <main id="main-content" className="overflow-x-hidden" data-id="element-729">
        <HeroSection data-id="element-730" />

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-732" />} data-id="element-731">
          <ClaridadSection data-id="element-733" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-735" />} data-id="element-734">
          <QueEsSection data-id="element-736" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-738" />} data-id="element-737">
          <MetodoSection data-id="element-739" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-741" />} data-id="element-740">
          <MecanismoNuevoSection data-id="element-742" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-744" />} data-id="element-743">
          <TestimoniosSection data-id="element-745" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-747" />} data-id="element-746">
          <QueIncluyeSection data-id="element-748" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-750" />} data-id="element-749">
          <LifestyleSection data-id="element-751" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-753" />} data-id="element-752">
          <PersonalizaSection data-id="element-754" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-756" />} data-id="element-755">
          <EmotionalCloseSection data-id="element-757" />
        </Suspense>

        <Suspense fallback={<div className="min-h-screen bg-dark" data-id="element-759" />} data-id="element-758">
          <IdentitySection data-id="element-760" />
        </Suspense>

        {/* BOTÓN FLOTANTE MOBILE */}
        <div className="fixed bottom-4 left-0 right-0 z-[9999] flex justify-center px-4 sm:hidden pointer-events-none" data-id="element-761">
          <button type="button" onClick={() => {
          document.getElementById('personaliza')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }} className="pointer-events-auto w-full max-w-md" aria-label="Ir a la sección de compra" data-id="element-762">
            <div className="relative overflow-hidden rounded-2xl border border-gold/30 bg-black/85 backdrop-blur-xl shadow-[0_10px_40px_rgba(212,175,55,0.25)]" data-id="element-763">
              <div className="absolute inset-0 bg-gradient-to-r from-gold/10 via-gold/5 to-gold/10 animate-pulse" data-id="element-764" />

              <div className="relative flex items-center justify-between px-5 py-4" data-id="element-765">
                <div className="flex flex-col text-left" data-id="element-766">
                  <span className="text-[11px] uppercase tracking-[0.2em] text-gold/70 font-semibold" data-id="element-767">
                    Código 888
                  </span>

                  <span className="text-white font-bold text-sm leading-tight" data-id="element-768">
                    Activar experiencia ahora
                  </span>
                </div>

                <span className="text-gold font-black text-xl" data-id="element-769">→</span>
              </div>
            </div>
          </button>
        </div>
      </main>

      <Suspense fallback={null} data-id="element-770">
        <Footer data-id="element-771" />
        <SalesNotification data-id="element-772" />
      </Suspense>

      <BackgroundAudio data-id="element-773" />
    </div>;
}